<script>
export default {
    name: "IconX"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 stroke-black"
         fill="none" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
